'use client'

import Image from 'next/image'

import logoIcon from '@images/navbar/logo_main-nav.svg'

import NavigateToContact from '@app/[locale]/investors/components/NavigateToContact'

import styles from '../jobs.module.scss'

type JobsCTASectionProps = {
  locale: string
}

export default function JobsCTASection({ locale }: JobsCTASectionProps): JSX.Element {
  return (
    <section className={styles.jobsCTASection}>
      <div className={styles.jobsCTAContainer}>
        <div className={styles.jobsCTACard}>
          <Image
            src={logoIcon}
            alt="SonicJobs"
            width={131}
            height={33}
            className={styles.jobsCTALogo}
            loading="lazy"
          />
          <h2 className={styles.jobsCTATitle}>
            Your next career move.<br />
            Sorted.
          </h2>
          <p className={styles.jobsCTADescription}>
            Apply to thousands of jobs with one click using our AI-powered platform.
          </p>
          <NavigateToContact locale={locale} className={styles.jobsCTAButton}>
            Get Started
          </NavigateToContact>
        </div>
      </div>
    </section>
  )
}
